// @flow
import React, { useCallback } from 'react';
import Lighting from './Lighting';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from '../../constant';
import { setDeviceContainerStatus, toggleLightingMenuVisibility } from '../../redux/tool-webjam-v2/actions';
import { connect } from '../../../base/redux';
import { useDispatch } from 'react-redux';
import ToolboxButtonWithIconPopup from '../../../base/toolbox/components/web/ToolboxButtonWithIconPopup';
import { IconArrowUp } from '../../../base/icons';
import LightingButtonActions from './LightingButtonActions';
import { getBaseConfig } from '../../Utils';
import { isLocalParticipantModerator } from '../../../base/participants';
import { getActiveSession } from '../../../recording';
import { JitsiRecordingConstants } from '../../../base/lib-jitsi-meet';
import { showToastPopup } from '../../redux/tool-webjam/actions';
import CustomTooltip from './CustomTooltip';
import { ct } from '../../constant-Utils';


const BoxIndicatorButton = (props) => {
    const { usersData, isOpen, visible, _isLiveStreamRunning, _isRecordingRunning, isModerator } = props;
    const dispatch = useDispatch()

    const handleClick = (value) => {
        if (_isLiveStreamRunning == false && _isRecordingRunning == false) {
            dispatch(setDeviceContainerStatus(value, 'BoxIndicatorButton'))
        } else {
            if (isModerator) {
                if (_isRecordingRunning) {
                    dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.recRestrictions.webjamModeratorMsg") }));
                } else {
                    dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.streamRestrictions.webjamModeratorMsg") }));
                }
            } else {
                if (_isRecordingRunning) {
                    dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.recRestrictions.webjamParticipantMsg") }));
                } else {
                    dispatch(showToastPopup({ toastModal: true, modalText: ct("Translate.streamRestrictions.webjamParticipantMsg") }));
                }
            }

            setTimeout(function () {
                dispatch(showToastPopup({ toastModal: false, modalText: "" }));
            }, 10000)
        }
    }

    const toggleLightingMenu = useCallback(() => {
        dispatch(toggleLightingMenuVisibility(false));
    }, [dispatch]);

    const openLightingMenu = useCallback(() => {
        dispatch(toggleLightingMenuVisibility(true));
    }, [dispatch]);

    const lightingMenu = (<div className='lighting-menu-container'>
        <LightingButtonActions />
    </div>);

    let disabledLightingIcon = getBaseConfig('disabledLightingIcon')

    return (
        <>
            {usersData?.users?.length > 0 ?
                <div id="box-indicator" key={`indicator-${visible ? 'on' : 'off'}`} className="btm-bar-icon lighting-green" onClick={() => {
                    dispatch(toggleLightingMenuVisibility(!visible));
                }}>

                    <div
                        className="btm-bar-icon selected"
                    >
                        <CustomTooltip className="cus-tooltip" content={ct("rta-trmc.toolBox.connectedRTADevice")}>
                            <Lighting
                                height={"18"}
                                width={"18"}
                            />
                        </CustomTooltip>
                        <div className='icon-over-lighting'>
                            <CustomTooltip className="cus-tooltip" content={ct("rta-trmc.toolBox.audioDeviceOptions")}>
                                <ToolboxButtonWithIconPopup
                                    ariaControls='lighting-menu-dialog'
                                    ariaExpanded={isOpen}
                                    ariaHasPopup={true}
                                    icon={IconArrowUp}
                                    iconDisabled={false}
                                    iconId='lighting-menu-button'
                                    onPopoverClose={toggleLightingMenu}
                                    onPopoverOpen={openLightingMenu}
                                    popoverContent={lightingMenu}
                                    visible={visible}
                                >
                                </ToolboxButtonWithIconPopup>
                            </CustomTooltip>
                        </div>
                    </div>
                </div>
                :
                <div id="box-indicator" key='indicator' className="btm-bar-icon lighting-white" onClick={() => handleClick("open")} >
                    <div >
                        <span className="cus-tooltip">{ct("rta-trmc.toolBox.enableLowLatency")}</span>
                        <img src={disabledLightingIcon} />
                    </div>
                </div>
            }
        </>
    )
}

function _mapStateToProps(state) {
    return {
        usersData: state[FEATURE_CUSTOM_REDUX].usersData,
        isOpen: state[FEATURE_CUSTOM_REDUX_V2].lightingMenuVisibility,
        visible: state[FEATURE_CUSTOM_REDUX_V2].lightingMenuVisibility,
        isModerator: isLocalParticipantModerator(state),
        _isLiveStreamRunning: Boolean(getActiveSession(state, JitsiRecordingConstants.mode.STREAM)),
        _isRecordingRunning: Boolean(getActiveSession(state, JitsiRecordingConstants.mode.FILE)),
    };
}

export default connect(_mapStateToProps)(BoxIndicatorButton);
